import { googleRecaptchaResponse } from "../../api/recaptcha/siteverify.api";
import { loadCities } from "../../api/rest-forecasts/cities.api";
import { loadForecastsWeather } from "../../api/rest-forecasts/forecasts.api";
import { loadDailyForecastWeather } from "../../api/forecasts/daily-forecast.api";
import { loadHourlyForecastWeather } from "../../api/forecasts/hourly-forecast.api";
import { loadCounty } from "../../api/telemetry";

import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const state = {
  recaptcha: {},
  cities: [],
  forecastsWeather: [],
  dailyForecastWeather: [],
  hourlyForecastWeather: [],
  hourlyCardForecastWeather: [],
  county: {}
};

const mutations = {
  setRecaptcha(state, data) {
    state.recaptcha = data ? data : [];
  },
  setCities(state, data) {
    state.cities = data ? data : [];
  },
  setForecastsWeather(state, data) {
    state.forecastsWeather = data ? data : [];
  },
  setDailyForecastWeather(state, data) {
    state.dailyForecastWeather = data ? data : [];
  },
  setHourlyForecastWeather(state, data) {
    state.hourlyForecastWeather = data ? data : [];
  },
  setCardHourlyForecastWeather(state, data) {
    state.hourlyCardForecastWeather = data ? data : [];
  },
  setCounty(state, data) {
    state.county = data ? data : {};
  },
};

const actions = {
  async googleRecaptchaResponse({ commit }, payload) {
    try {
      const response = await googleRecaptchaResponse({ ...payload });
      commit('setRecaptcha', response.data);
    } catch (error) {
      commit('setRecaptcha', undefined);
    }
  },

  async loadForecastsWeather({ commit }, payload) {
    try {
      const response = await loadForecastsWeather({ ...payload });
      commit('setForecastsWeather', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações de previsão.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setForecastsWeather', undefined);
    }
  },

  async loadDailyForecastWeather({ commit }, payload) {
    try {
      const response = await loadDailyForecastWeather({ ...payload });
      commit('setDailyForecastWeather', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações da previsão diária.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setDailyForecastWeather', undefined);
    }
  },

  async loadHourlyForecastWeather({ commit }, payload) {
    try {
      const response = await loadHourlyForecastWeather({ ...payload });
      commit('setHourlyForecastWeather', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações da previsão horária.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setHourlyForecastWeather', undefined);
    }
  },

  async loadHourlyCardForecastWeather({ commit }, payload) {
    try {
      const response = await loadHourlyForecastWeather({ ...payload });
      commit('setCardHourlyForecastWeather', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações do card de previsão horária.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setCardHourlyForecastWeather', undefined);
    }
  },

  async loadCounty({ commit }, payload) {
    try {
      const response = await loadCounty({ ...payload });
      commit('setCounty', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos município.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setCounty', undefined);
    }
  },

  async loadCities({ commit }) {
    try {
      const response = await loadCities();
      commit('setCities', response.data);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das cidades.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setCities', undefined);
    }
  },
};

const getters = {
  recaptcha: (state) => state.recaptcha,
  cities: (state) => state.cities,
  forecastsWeather: (state) => state.forecastsWeather,
  dailyForecastWeather: (state) => state.dailyForecastWeather,
  hourlyForecastWeather: (state) => state.hourlyForecastWeather,
  hourlyCardForecastWeather: (state) => state.hourlyCardForecastWeather,
  county: (state) => state.county,
};
export default {
  state,
  mutations,
  actions,
  getters
}
